export interface FiscalYearOption {
  value: string;
  label: string;
}

export const buildFiscalYearOptions = (
  currentFiscalYear: number,
  { pastYears = 10, futureYears = 5 } = {},
): FiscalYearOption[] => {
  const options: FiscalYearOption[] = [];
  for (
    let year = currentFiscalYear + futureYears;
    year >= currentFiscalYear - pastYears;
    year -= 1
  ) {
    options.push({ value: String(year), label: `${year}年度` });
  }
  return options;
};
